import types from "./types";

const initState = {
    loading: false,
    contentType: 'charting',
    modalMode: null,
    templatesLoading: false,
    selectedChartingPrescription: null,
    chartingEntries: [],
    providerNotes: [],
    unreadProviderNotesCount: 0,
    rawEntry: '',
    compiledEntry: '',
    templates: [],
    queuedPrescriptions: [],
    selectedTemplate: null,
    selectedItem: null,
    chartingNoteIsAdded: false,
    chartingRequirementIsMet: false
}

export default function charting(state = initState, action) {
    switch(action.type) {
        case types.SET_CONTENT_TYPE:
            return {
                ...state,
                contentType: action.payload
            }
        case types.SET_CHARTING_TEMPLATES:
            return {
                ...state,
                templates: action.payload
            }
        case types.SET_QUEUED_PRESCRIPTIONS:
            return {
                ...state,
                queuedPrescriptions: action.payload
            }
        case types.SET_CHARTING_ENTRIES:
            return {
                ...state,
                chartingEntries: action.payload
            }
        case types.SET_PROVIDER_NOTES: 
            return {
                ...state,
                providerNotes: action.payload
            }
        case types.SET_UNREAD_PROVIDER_NOTES_COUNT:
            return {
                ...state,
                unreadProviderNotesCount: action.payload
            }
        case types.SET_RAW_ENTRY:
            return {
                ...state,
                rawEntry: action.payload
            }
        case types.SET_COMPILED_ENTRY:
            return {
                ...state,
                compiledEntry: action.payload
            }
        case types.SELECT_CHARTING_PRESCRIPTION:
            return {
                ...state,
                selectedChartingPrescription: action.payload
            }
        case types.SET_CHARTING_NOTE_ADDED:
            return {
                ...state,
                chartingNoteIsAdded: action.payload
            }
        case types.RESET_CHARTING_ENTRY:
            return {
                ...state,
                selectedTemplate: null,
                rawEntry: '',
                compiledEntry: ''
            }
        case types.EVALUATE_CHARTING_REQUIREMENTS:
            const { caseDetails } = action.payload
            const isWeightManagementCase = caseDetails?.category.slug === 'weight-management'
            // REVERT WHEN MOVING TO SEMA+, MOVE LOGIC TO TEMPLATE-LEVEL
            const chartingRequirementIsMet = true
            // const chartingRequirementIsMet = !isWeightManagementCase || state.chartingNoteIsAdded
            return {
                ...state,
                chartingRequirementIsMet
            }
        case types.SELECT_TEMPLATE:
            return {
                ...state,
                selectedTemplate: action.payload
            }
        case types.SELECT_ITEM:
            return {
                ...state,
                selectedItem: action.payload
            }
        case types.SET_MODAL_MODE:
            return {
                ...state,
                modalMode: action.payload
            }
        default:
            return state
    }
}